import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleInfo,
  faTriangleExclamation,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';

export type BannerType = 'info' | 'warning' | 'critical';

export interface Banner {
  id: number;
  heading: string;
  subheading: string | null;
  type: BannerType;
  start_at: string;
  end_at: string | null;
  non_dismissible: boolean;
  created_at?: string;
  created_by?: string | null;
  updated_at?: string;
  updated_by?: string | null;
}

export type BannerStatus = 'live' | 'scheduled' | 'expired';

export const MAX_HEADING_LENGTH = 150;
export const MAX_SUBHEADING_LENGTH = 500;

export const BANNER_TYPES: BannerType[] = ['info', 'warning', 'critical'];

export const TYPE_LABELS: Record<BannerType, string> = {
  info: 'Info',
  warning: 'Warning',
  critical: 'Critical',
};

export const TYPE_ICONS: Record<BannerType, IconDefinition> = {
  info: faCircleInfo,
  warning: faTriangleExclamation,
  critical: faCircleXmark,
};

export const STATUS_LABELS: Record<BannerStatus, string> = {
  live: 'Live',
  scheduled: 'Scheduled',
  expired: 'Expired',
};

export const getBannerStatus = (start: string | null, end: string | null): BannerStatus => {
  const now = Date.now();
  if (start && now < new Date(start).getTime()) return 'scheduled';
  if (end && now >= new Date(end).getTime()) return 'expired';
  return 'live';
};

export const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return 'No end';
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
